import axios from 'axios';

const list = (data) => axios.get('/safe/video/list2', data);
const save = (data) => axios.post('/safe/video/save', data);
const del = (data) => axios.post('/safe/video/delete', data);

const genreSave = (data) => axios.post('/safe/genre/save', data);
const genreDel = (data) => axios.post('/safe/genre/delete', data);

//获取海康摄像头
const cameraSearch = (data) => axios.get('/safe/ai/cameraSearch', data);

const getCameraPreviewURL = (data) => axios.get('/safe/ai/getCameraPreviewURL', data);

export default {
  list,
  save,
  del,
  genreSave,
  genreDel,
  cameraSearch,
  getCameraPreviewURL,

}


